<template>
    <div>
        <div class="content-header row">
            <div class="content-header-left col-md-6 col-12 mb-2">
                <h3 class="content-header-title mb-0">Vehicles</h3>
                <div class="row breadcrumbs-top">
                    <div class="breadcrumb-wrapper col-12">
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item"><a href="/">Home</a>
                            </li>
                            <li class="breadcrumb-item active">Vehicles
                            </li>
                        </ol>
                    </div>
                </div>
            </div>
            <div class="content-header-right col-md-6 col-12 mb-md-0 mb-2">
                <div class=" float-md-right">
                    <button v-if="vehicle.admin_approval_status === 'pending'" @click.prevent="updateStatus('rejected')" type="button" class="btn btn-warning mr-1">
                        <i class="feather icon-check icon-left"></i>
                        Mark as Rejected
                    </button>
                    <button v-if="vehicle.admin_approval_status !== 'approved'" data-toggle="modal"
                        @click.prevent="updateStatus('approved')"
                        data-target="#resolved-modal"
                        type="button" class="btn btn-outline-primary"
                    >
                        <i class="feather icon-check icon-left"></i>
                        Mark as Approved
                    </button>
                </div>
            </div>
        </div>

        <div class="content-body">
            <section class="users-view">
                <div class="card">
                    <div class="card-content">
                        <div class="card-body">
                            <div class="row">
                                <div class="col-md-6">
                                    <h3 class="mb-1"><i class="feather icon-info"></i> Vehicle Details</h3>
                                    <table class="table table-borderless">
                                        <tbody>
                                            <tr>
                                                <td>Vehiclce Id:</td>
                                                <td>{{ vehicle.id }}</td>
                                            </tr>
                                            <tr>
                                                <td>Vehicle Type:</td>
                                                <td>{{ vehicle.type.name }}</td>
                                            </tr>
                                            <tr>
                                                <td>Vehicle Make:</td>
                                                <td>{{ vehicle.vehicle_make }}</td>
                                            </tr>
                                            <tr>
                                                <td>Vehicle Model:</td>
                                                <td>{{ vehicle.vehicle_model }}</td>
                                            </tr>
                                            <tr>
                                                <td>Vehicle Name:</td>
                                                <td>{{ vehicle.name }}</td>
                                            </tr>
                                            <tr>
                                                <td>Vehicle License Number:</td>
                                                <td>{{ vehicle.license_plate }}</td>
                                            </tr>
                                            <tr>
                                                <td>Owner:</td>
                                                <td>
                                                    <a :href="vehicle.ownership_type === 'fleet_managed' ? route('admin.fleet_managers.show', vehicle.fleet_manager.id) :  route('admin.drivers.show', vehicle.driver.id)">
                                                        {{ vehicle.ownership_type === 'fleet_managed' ? vehicle.fleet_manager.full_name :  vehicle.driver.full_name }}
                                                    </a>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>Vehicle Owner Type:</td>
                                                <td>{{ vehicle.ownership_type }}</td>
                                            </tr>
                                            <tr>
                                                <td>Driver:</td>
                                                <td>
                                                    <a v-if="vehicle.driver" :href="route('admin.drivers.show', vehicle.driver.id)">
                                                        {{ vehicle.driver.full_name }}
                                                    </a>
                                                    <span v-else>Unassigned</span>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>Vehicle Status:</td>
                                                <td>
                                                    <span :class="'users-view-status badge badge-' + statusClass(vehicle.status)"
                                                    >
                                                        {{ vehicle.status }}
                                                    </span>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>Vehicle added at:</td>
                                                <td>
                                                    {{ formatDateTime(vehicle.created_at) }}
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>Total number of trips:</td>
                                                <td>{{ vehicle.trips_count }}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section class="card">
                <div class="card-header">
                    <h4><i class="feather icon-info"></i> Vehicle Documents</h4>
                </div>

                <div class="card-body">
                    <table id="recent-user-documents"
                           class="table table-responsive">
                        <thead>
                            <tr>
                                <th>S/N</th>
                                <th>Document Name</th>
                                <th style="width: 10px">Document</th>
                                <th>Status</th>
                                <th>Date Submitted</th>
                                <th>Expiry Date</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(document, i) in vehicle.document_data" :key="document.id">
                            <td class="text-truncate">{{ i + 1 }}</td>
                            <td class="text-truncate"> {{ document.name }}</td>
                            <td class="text-truncate" style="width: 10px">
                                <a :href="document.url">
                                    <img :src="document.url" :alt="document.name" style="width: 40px; height: 40px; object-fit: cover; border-radius: 6px;">
                                </a>
                            </td>
                            <td class="text-truncate">
                                 <span class="badge badge-glow"
                                       :class="document.status === 'approved' ? 'badge-primary'
                                       : (document.status === 'submitted' || document.status === 'pending'  ? 'badge-warning': 'badge-danger')">
                                {{ document.status }}
                            </span>
                            </td>
                            <td class="text-truncate">{{ formatDateTime(document.date_created) }}</td>
                            <td class="text-truncate">{{ formatDateTime(document.expiry_date) }}</td>
                            <td class="text-truncate">
                                <a v-if="document.status !== 'approved' " href="#"
                                   @click.prevent="resolvedModal(document.id, 1, document.name === 'Vehicle Photo')">
                                    <i class="feather icon-check"></i> approve
                                </a>
                                <span v-if="document.status !== 'rejected' && document.status !== 'approved'">|</span>
                                <a v-if="document.status !== 'rejected'" href="#" @click.prevent="resolvedModal(document.id, 0)"
                                   class="text-danger">
                                    <i class="feather icon-edit"></i> reject
                                </a>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </section>
        </div>
        <div class="modal fade resolved-modal" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel"
             aria-hidden="true">
            <div class="modal-dialog">
                <div class="modal-content">
                    <form @submit.prevent="documentData.status === 1 ? approve(documentData.id) : reject(documentData.id)">
                        <div class="modal-header">
                            <h4 id="myModalLabel1" class="modal-title">
                                {{ documentData.status === 1 ? 'Document Expiry' : 'Rejection Reason' }}
                            </h4>
                            <button type="button" data-dismiss="modal" aria-label="Close" class="close">
                                <span aria-hidden="true">×</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <div class="form-group">
                                <label>
                                    {{ documentData.status === 1 ? 'Document Expiry Date' : 'Rejection Reason' }}
                                </label>
                                <textarea v-if="documentData.status === 0" required class="form-control"
                                    v-model="documentData.reason_for_rejection"
                                ></textarea>
                                <div v-if="errors.reason_for_rejection" class="text-danger text-small">
                                    {{ errors.reason_for_rejection }}
                                </div>

                                <input v-if="documentData.status === 1" type="date" class="form-control"
                                    required
                                    v-model="documentData.expiry_date"
                                >
                                <div v-if="errors.expiry_date" class="text-danger text-small">
                                    {{ errors.expiry_date }}
                                </div>
                            </div>

                        </div>

                        <div class="modal-footer">
                            <button class="btn btn-primary" :disabled="saving">
                                Submit <i class="fa fa-spinner fa-spin" v-if="saving"/>
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import th from "vue2-datepicker/locale/es/th";

export default {
    metaInfo: {title: 'Vehicle'},
    name: 'VehicleShow',
    props: ['vehicle'],
    layout: Layout,
    data: () => ({
        saving: false,
        documentData : {
            id: null,
            status: null,
            expiry_date: null,
            reason_for_rejection: null,
        },
        errors: {}
    }),
    methods: {
        async updateStatus(value) {
            this.saving = true

            this.$inertia.put(route('admin.vehicles.update', this.vehicle.id),
                {status: value}, {
                    preserveScroll: true,
                    onSuccess: () => {
                        this.saving = false
                    },
                    onError: (response) => {
                        this.saving = false
                    }
                });
        },
        approve(documentId) {
            this.$inertia.patch(route('admin.drivers.document.approve', [this.vehicle.id, documentId]),
                {expiry_date: this.documentData.expiry_date}, {
                    preserveScroll: true,
                    onSuccess: () => {
                        $('.resolved-modal').modal('hide');
                    },
                    onError: (response) => {
                        this.errors = response
                    }
                });
        },
        reject(documentId) {
            this.$inertia.post(route('admin.drivers.document.reject', [this.vehicle.id, documentId]),
                {reason_for_rejection: this.documentData.reason_for_rejection}, {
                    preserveScroll: true,
                    onSuccess: () => {
                        $('.resolved-modal').modal('hide');
                    },
                    onError: (response) => {
                        this.errors = response
                    }
                });
        },
        resolvedModal(id, status, vehiclePhoto = false) {
            this.documentData.id = id;
            this.documentData.status = status
            this.documentData.reason_for_rejection = '';
            this.documentData.expiry_date = '';
            this.errors = {}

            if (status && vehiclePhoto) {
                this.approve(id)

                return;
            }

            $('.resolved-modal').modal('show');
        },
        formatDateTime(value) {
            if (!value) return value

            const date = new Date(value);
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            const hours = String(date.getHours()).padStart(2, '0');
            const minutes = String(date.getMinutes()).padStart(2, '0');

            return `${year}-${month}-${day} ${hours}:${minutes}`;
        },
        statusClass(value) {
            if (value === 'verification_failed' || value === 'suspended') {
                return "danger";
            }
            else if (value === 'verifying')
            {
                return "warning";
            } else if (value === 'active')
            {
                return "primary";
            }
            else
            {
                return "success";
            }
        },
    },
    mounted() {

    },
}
</script>
